import { DefinitionDto } from "@app/modules/shared/model/definition.dto";
import { SectorDto } from "@dashboard/modules/management/sector/model/sector.dto";
import { LocationDto } from "@app/data/management/models/location.dto";
import { CurrencyDto } from "@app/data/management/models/currency.dto";

export class CustomerDto extends DefinitionDto {
  type?: string;
  is_private?: string;
  identity_num?: string;
  tax_office?: string;
  tax_num?: string;
  current_account?: SectorDto;
  currency?: CurrencyDto;
  sector?: SectorDto;
  country?: LocationDto;
  region?: LocationDto;
  state?: LocationDto;
  city?: LocationDto;
  county?: LocationDto;
  address?: string;
  phone?: string;
  phone2?: string;
  fax_num?: string;
  email_address?: string;
  authorized_name?: string;
  authorized_surname?: string;
  authorized_email?: string;
  authorized_phone?: string;
}
